export default import.meta.ROLLDOWN_FILE_URL_dtJlb7WxA$YTmj6$fFe_Ow